import { render } from "./Foreign.vue?vue&type=template&id=540c6a72&ts=true"
import script from "./Foreign.vue?vue&type=script&lang=ts"
export * from "./Foreign.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__